import { extensionOf } from '../../lib/format.ts';
import {
  IconArchive, IconFile, IconFolder, IconImage, IconMusic, IconVideo,
} from '../../lib/icons.tsx';
import type { ApiNode } from '../../api/types.ts';

const ARCHIVE = new Set(['zip', 'gz', 'tar', 'rar', '7z', 'bz2', 'xz']);

interface Props { node: Pick<ApiNode, 'type' | 'name' | 'mime'>; size?: number }

export function FileIcon({ node, size = 20 }: Props) {
  if (node.type === 'folder') {
    return <IconFolder size={size} className="ficon ficon--folder" />;
  }

  const mime = node.mime ?? '';
  const ext = extensionOf(node.name);

  if (mime.startsWith('image/')) return <IconImage size={size} className="ficon" />;
  if (mime.startsWith('video/')) return <IconVideo size={size} className="ficon" />;
  if (mime.startsWith('audio/')) return <IconMusic size={size} className="ficon" />;
  if (ARCHIVE.has(ext)) return <IconArchive size={size} className="ficon" />;
  return <IconFile size={size} className="ficon" />;
}
